export const AVAILABLE_ROUTES = {
  DASHBOARD: '/',
  LOGIN: '/login',
  RECEIVING: '/Receiving',
  PLACING: '/Placed',
  SHIPPING_OUT: '/ShippedOut',
}
